export default "__VITE_ASSET__mjQQ4cdM__"